import React from "react";

import type { JSX } from "react";

interface TooltipLinesProps {
  lines: (string | null | undefined)[];
}

/** Contenu d'infobulle sur plusieurs lignes, à rendre avec `renderToStaticMarkup` dans `data-tooltip-html`. */
function TooltipLines({ lines }: TooltipLinesProps): JSX.Element | null {
  const lineList = lines.filter(Boolean);
  if (lineList.length === 0) return null;

  return (
    <React.Fragment>
      {lineList.map((line) => (
        <div key={line}>{line}</div>
      ))}
    </React.Fragment>
  );
}

export default TooltipLines;
